import { Type } from '@sinclair/typebox';
import { UuidSchema } from './common.js';
import { TfPromptSchema, TfPromptVersionSchema } from './tables.js';
const InputsSchema = Type.Array(Type.String({ minLength: 1, maxLength: 128 }));
const CreatedBySchema = Type.String({ maxLength: 256 });
// POST /prompts
export const CreatePromptBodySchema = Type.Object({
    trackId: UuidSchema,
    name: Type.String({ minLength: 1, maxLength: 255 }),
    description: Type.Optional(Type.String({ maxLength: 2048 })),
    content: Type.String({ minLength: 1 }),
    inputs: Type.Optional(InputsSchema),
    createdBy: Type.Optional(CreatedBySchema),
});
// GET /prompts
export const ListPromptsQuerySchema = Type.Object({
    trackId: Type.Optional(UuidSchema),
});
// GET /prompts/lookup?trackId=&name=
export const LookupPromptQuerySchema = Type.Object({
    trackId: UuidSchema,
    name: Type.String({ minLength: 1, maxLength: 255 }),
});
// PATCH /prompts/:id
export const UpdatePromptBodySchema = Type.Object({
    name: Type.Optional(Type.String({ minLength: 1, maxLength: 255 })),
    description: Type.Optional(Type.String({ maxLength: 2048 })),
});
// :id path param
export const PromptIdParamsSchema = Type.Object({
    id: UuidSchema,
});
// :id + :version path params
export const PromptVersionParamsSchema = Type.Object({
    id: UuidSchema,
    version: Type.String({ pattern: '^[0-9]+$' }),
});
// POST /prompts/:id/versions
export const CreatePromptVersionBodySchema = Type.Object({
    content: Type.String({ minLength: 1 }),
    inputs: Type.Optional(InputsSchema),
    createdBy: Type.Optional(CreatedBySchema),
});
// POST /prompts/upsert-defaults
export const UpsertDefaultsBodySchema = Type.Object({
    trackId: UuidSchema,
    prompts: Type.Array(Type.Object({
        name: Type.String({ minLength: 1, maxLength: 255 }),
        description: Type.Optional(Type.String({ maxLength: 2048 })),
        content: Type.String({ minLength: 1 }),
        inputs: Type.Optional(InputsSchema),
        createdBy: Type.Optional(CreatedBySchema),
    })),
});
export const UpsertDefaultsResponseSchema = Type.Object({
    created: Type.Integer({ minimum: 0 }),
    updated: Type.Integer({ minimum: 0 }),
    unchanged: Type.Integer({ minimum: 0 }),
});
// POST /prompts/:id/render
export const RenderPromptBodySchema = Type.Object({
    inputs: Type.Record(Type.String(), Type.String()),
    version: Type.Optional(Type.Integer({ minimum: 1 })),
});
export const RenderPromptResponseSchema = Type.Object({
    rendered: Type.String(),
    promptId: UuidSchema,
    version: Type.Integer(),
    inputs: Type.Array(Type.String()),
});
// Responses
export const PromptResponseSchema = TfPromptSchema;
export const PromptsListResponseSchema = Type.Array(TfPromptSchema);
export const PromptWithLatestVersionSchema = Type.Intersect([
    TfPromptSchema,
    Type.Object({
        latestVersion: Type.Union([TfPromptVersionSchema, Type.Null()]),
    }),
]);
// When the prompt was just created, latestVersion is always present.
export const PromptWithInitialVersionSchema = Type.Intersect([
    TfPromptSchema,
    Type.Object({ latestVersion: TfPromptVersionSchema }),
]);
export const PromptVersionResponseSchema = TfPromptVersionSchema;
export const PromptVersionsListResponseSchema = Type.Array(TfPromptVersionSchema);
//# sourceMappingURL=prompts.js.map